import api from './api'

export default class ApiPortfolio {

    // Получение списка групп оператора
    static async getGroups(): Promise<any> {
        try {
            return await api.get('/portfolio/getGroups')
        } catch (error) {
            return error
        }
    }

    // Получение списка студентов
    static async getStudents(groupOID: string): Promise<any> {
        try {
            return await api.get(`/portfolio/getStudents?groupOID=${groupOID}`)
        } catch (error) {
            return error
        }
    }

    // Получение списка файлов
    static async getFiles(studentID: string): Promise<any> {
        try {
            return await api.get(`/portfolio/getFiles?studentID=${studentID}`)
        } catch (error) {
            return error
        }
    }

    // Загрузка файлов Портфолио
    static async uploadPortfolio(file: any, studentID: string, fileType: string, fileName: string): Promise<any> {
        const formData = new FormData()
        formData.append("portfolio", file)

        try {
            return await api.post(`/portfolio/uploadPortfolio?studentID=${studentID}&fileType=${fileType}&fileName=${fileName}`, formData, { headers: { "Content-Type": `multipart/form-data` } })
        } catch (error) {
            return error
        }
    }

    // Удаление файла
    static async deleteFile(fileID: number): Promise<any> {
        try {
            return await api.delete(`/portfolio/deleteFile?fileID=${fileID}`)
        } catch (error) {
            return error
        }
    }
    
}